import script from "./xinhuodongzshd.vue?vue&type=script&setup=true&lang=js"
export * from "./xinhuodongzshd.vue?vue&type=script&setup=true&lang=js"

import "./xinhuodongzshd.vue?vue&type=style&index=0&id=2e70f776&scoped=true&lang=css"

import exportComponent from "D:\\doc\\project\\kepukeyanchengguozhanshi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e70f776"]])

export default __exports__